export const textPdfV = process.env.REACT_APP_UEV_RGPD;
export const textPdfM = process.env.REACT_APP_UEM_RGPD;
export const textPdfC = process.env.REACT_APP_UEC_RGPD;
export const textPdfA = process.env.REACT_APP_UEA_RGPD;